export default {
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: '#1e88e5',
  },
};
